import React, { useState, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextInput from 'app/components/TextInput';
import { Select, Divider, Checkbox, Button, message, Drawer } from 'antd';

import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import FrontContainer from 'app/containers/FrontContainer';
import ACCPSupervisorTableContainer from 'app/containers/ACCPSupervisorTableContainer';
import SSPARepresentativeTableContainer from 'app/containers/SSPARepresentativeTableContainer';
import TechnicalRepresentativeTableContainer from 'app/containers/TechnicalRepresentativeTableContainer';
import AdministrativeRepresentativeTableContainer from 'app/containers/AdministrativeRepresentativeTableContainer';
import PEPRepresentativeTableContainer from 'app/containers/PEPRepresentativeTableContainer';
import ACCPBossTableContainer from 'app/containers/ACCPBossTableContainer';
import ApiService from 'app/services/ApiService';

import { clearFront } from 'app/actions/FrontActions';
import { clearCommunicationProgram } from 'app/actions/CommunicationProgramActions';
import { accpSupervisorClear } from 'app/actions/ACCPSupervisorActions';
import { sspaRepresentativeClear } from 'app/actions/SSPARepresentativeActions';
import { technicalRepresentativeClear } from 'app/actions/TechnicalRepresentativeActions';
import { administrativeRepresentativeClear } from 'app/actions/AdministrativeRepresentativeActions';
import { pepRepresentativeClear } from 'app/actions/PEPRepresentativeActions';
import { accpBossClear } from 'app/actions/ACCPBossActions';
import { useDispatch, useSelector } from 'react-redux';
import { employeeById } from 'app/reducers';


import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ClientReportScreenStyles';

const CheckboxGroup = Checkbox.Group;

const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = [...new Set(name.map(i => i[value]))];
    x = name.map(i => i[value]);
    return (
        x.map((c, i) => <Option key={i}>{c}</Option>)
    );
}
const options1 = [
    'Inventario de procesos, funciones y actividades.',
    'Índice de calidad y documentos operativos.', 
    'Matriz de documentos operativos.',
];
const options2 = [
    'Meses del programa en función del PDC ',
];

export default function ClientReportScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const userData = useSelector(employeeById)

    const [cp, setCP] = useState('');
    const [adminRep, setAdminRep] = useState('');
    const [front, setFront] = useState('');
    const [ACCP, setACCP] = useState('');
    const [accpBoss, setACCPBoss] = useState('');
    const [sspa, setSspa] = useState('');
    const [pep, setPep] = useState('');
    const [tr, setTr] = useState('');
    const [accp, setAccp] = useState('');
    const [isVisiblePDF, setVisiblePDF]= useState(false)
    const [PDFData, setPDFData]= useState();
    const [PFAInventory,setPFAInventory]=useState(false)
    const [FileIndexQuality,setFileIndexQuality]=useState(false)
    const [OperationalFileMatrix,setOperationalFileMatrix]=useState(false)
    const [OperativeFileMatrixCPP,setOperativeFileMatrixCPP]=useState(false)
    const [PDCProgram,setPDCProgram]=useState(false)

    const [SSPAList, setSSPAList ] = useState('');
    const [PEPList, setPEPList ] = useState('');
    const [TRList, setTRList ] = useState('');
    const [ACCPList, setACCPList ] = useState('');
    const [state, setState] = useState({
        indeterminate: true,
        checkAll: false,
      });
    
    const data ={
        idFront: front,
        SupervisorACCP: ACCP,
        BossACCP: accpBoss,
        AdministrativeRepresentative: adminRep,
        PEPRepresentative: pep,
        TechnicalRepresentative: tr,
        SSPARepresentative: sspa,
        ResponsibleCreator: accp,
        Inventory: PFAInventory,
        QualityIndex: FileIndexQuality,
        OperativeFiles: OperationalFileMatrix,
        FilesMatrix: OperativeFileMatrixCPP,
        IncludeMonths: PDCProgram,
        EmployeeId: userData.employeeId
    }

    useEffect(() => {
        return () => {
            dispatch(clearFront());
            dispatch(clearCommunicationProgram());
            dispatch(accpSupervisorClear());
            dispatch(sspaRepresentativeClear());
            dispatch(technicalRepresentativeClear());
            dispatch(administrativeRepresentativeClear());
            dispatch(pepRepresentativeClear());
            dispatch(accpBossClear());
        }
    }, []);

    const findCP = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.communicationProgram[values[i]].idCommunicationProgram;
            params.communicationProgram.forEach((v) => {
                if (v.idCommunicationProgram === id) {
                    temp.push(v);
                }
            });
        }
        setCP(String(temp[0].idCommunicationProgram));
    }
    const findAdminRep = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.administrativeRepresentative[values[i]].idResponsible;
            params.administrativeRepresentative.forEach((v) => {
                if (v.idResponsible === id) {
                    temp.push(v);
                }
            });
        }
        setAdminRep(String(temp[0].idResponsible));
    }

    const findFront = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.front[values[i]].idFront;
            params.front.forEach((v) => {
                if (v.idFront === id) {
                    temp.push(v);
                }
            });
        }
        setFront(String(temp[0].idFront));
    }
    
    const findACCP = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.accpSupervisor[values[i]].employeeId;
            params.accpSupervisor.forEach((v) => {
                if (v.employeeId === id) {
                    temp.push(v);
                }
            });
        }
        setACCP(String(temp[0].employeeId));
    }
    
    const findACCPBoss = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.accpBoss[values[i]].employeeId;
            params.accpBoss.forEach((v) => {
                if (v.employeeId === id) {
                    temp.push(v);
                }
            });
        }
        setACCPBoss(String(temp[0].employeeId));
    }
    
    const onChange = checkedList => {
        setState({
          checkedList,
        //   indeterminate: !!checkedList.length && checkedList.length < options1.length,
          checkAll: false,
        });
        setPFAInventory(false);
        setFileIndexQuality(false);
        setOperationalFileMatrix(false);
        checkedList.forEach(i=>{
           if(i==='Inventario de procesos, funciones y actividades.'){
               setPFAInventory(true);
            }else if(i==='Índice de calidad y documentos operativos.'){
                setFileIndexQuality(true);
           }else if (i=== 'Matriz de documentos operativos.'){
               setOperationalFileMatrix(true);
           }
        });
    };

    const onCheckAllChange = (e) => {
        setState({
          checkedList: e.target.checked ? options1 : [],
          indeterminate: false,
          checkAll: e.target.checked,
        });
        if(e.target.checked===true){
            setPFAInventory(true);
            setFileIndexQuality(true);
            setOperationalFileMatrix(true);
            setOperativeFileMatrixCPP(true);
            setPDCProgram(true)
        }else{
            setPFAInventory(false);
            setFileIndexQuality(false);
            setOperationalFileMatrix(false);
            setOperativeFileMatrixCPP(false);
            setPDCProgram(false)
        }
    };
    const onCheckMatrix = e => {
        setOperativeFileMatrixCPP(e.target.checked)
    };
    const onCheckChildChange = e => {
        setPDCProgram(e.target.checked)
    };

    const SelectSSPAItem = (name = [], value) => {
        setSSPAList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const SelectPEPItem = (name = [], value) => {
        setPEPList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const SelectTechnicalRepItem = (name = [], value) => {
        setTRList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    
    const SelectACCPItem = (name = [], value) => {
        setACCPList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            setSspa([])
            switch (key) {
                case 'responsibleName':
                    setSspa([])
                    break;
                case 'techResponsibleName':
                    setTr([])
                    break;
                case 'PEPresponsibleName':
                    setPep([])
                    break;
                case 'employeeName':
                    setAccp([])
                    break;
                default:
                    break;
            }
        }
        i.forEach(() => {
            if (key === 'responsibleName') {
                let newSSPAList = [];
                array.map(i => {
                    return SSPAList.map(ids => {
                        const res = ids['idResponsible'];
                        return ids.responsibleName === i ?  newSSPAList.push(res) :null
                    })
                })
                setSspa(String(newSSPAList))

            }else if(key=== 'techResponsibleName'){
                let newTRList = [];
                array.map(i => {
                    return TRList.map(ids => {
                        const res = ids['idResponsible'];
                        return ids.responsibleName === i ?  newTRList.push(res) :null
                    })
                })
                setTr(String(newTRList))

            }else if(key=== 'PEPresponsibleName'){
                let newPEPList = [];
                array.map(i => {
                    return PEPList.map(ids => {
                        const res = ids['idResponsible'];
                        return ids.responsibleName === i ?  newPEPList.push(res) :null
                    })
                })
                setPep(String(newPEPList))

            }else if(key=== 'employeeName'){
                let newACCPList = [];
                array.map(i => {
                    return ACCPList.map(ids => {
                        const res = ids['employeeId'];
                        return ids.employeeName === i ?  newACCPList.push(res) :null
                    })
                })
                setAccp(String(newACCPList))
            }
        })
    }

    const onSubmit = () => {
        setVisiblePDF(false)
        ApiService.getClientReports(data, cp)
            .then(
                result => {
                    setPDFData(result)
                    setVisiblePDF(true)
                },
                error => {
                    message.error('Ops! Ocurrió un error, intente nuevamente.');
                    // dispatch(clientReportError());
                    // eslint-disable-next-line no-throw-literal
                })
    }
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Gestión' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                            </Link>
                        <TextEvents
                            text="Reportes para el Cliente"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Grid container spacing={0}>
                    <Grid item xs={12} md={4}>
                        <Paper className={classes.rootPaper}>
                            <Grid container direction='row'>
                                <Grid item xs={12}>
                                    <Divider orientation="left" style={styles.dividerDefault}>Parámetros de generación</Divider>
                                </Grid>
                                <Grid item xs={12}>
                                    <CommunicationProgramContainer>
                                        {(params)=> {
                                            return  <TextInput
                                                        text='Programa de comunicación'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                        placeholder='Selecciona programa de comunicación'
                                                        style={styles.inputSelect}
                                                        showSearch
                                                        onChange={(v) => {
                                                            findCP(params, v);
                                                        }}
                                                    >
                                                        {SelectItem(params.communicationProgram, 'communicationProgramName')}
                                                    </TextInput>
                                        }}
                                    </CommunicationProgramContainer>
                                </Grid>
                                <Grid item xs={12}>
                                    <FrontContainer>
                                        {(front)=> {
                                            return  <TextInput
                                                        text='Frente'
                                                        color='darker'
                                                        size='label'
                                                        weight='medium'
                                                        placeholder='Selecciona frente'
                                                        style={styles.inputSelect}
                                                        showSearch
                                                        onChange={(v) => {
                                                            findFront(front, v);
                                                        }}
                                                    >
                                                        {SelectItem(front.front, 'frontName')}
                                                    </TextInput>
                                            }}
                                    </FrontContainer>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Paper className={classes.rootPaper} style={{fontSize: '10px', height: '194px'}}>
                            <Grid container direction='row'>
                                <Grid item xs={12}>
                                    <Divider orientation="left" style={styles.dividerDefault}>Secciones del reporte</Divider>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ borderBottom: '1px solid #E9E9E9', marginBottom:'10px', fontSize: '10px'}}>
                                    <Checkbox
                                        indeterminate={state.indeterminate}
                                        onChange={onCheckAllChange}
                                        checked={state.checkAll}
                                    >
                                        <label style={{fontSize:'10px', paddingBottom: '10px'}}>Marcar todo</label>
                                    </Checkbox>
                                </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                        <CheckboxGroup
                                        options={options1}
                                        value={state.checkedList}
                                        onChange={onChange}
                                        />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Checkbox onChange={onCheckMatrix} checked={OperativeFileMatrixCPP}>
                                        Matriz de documentos operativos por puesto o programa de comunicación.
                                    </Checkbox>
                                    <Checkbox style={{paddingLeft: '25px', paddingBottom: '5px'}}
                                    onChange={onCheckChildChange} checked={PDCProgram} disabled={!OperativeFileMatrixCPP}>
                                        Meses del programa en función del PDC.
                                    </Checkbox>
                                        <TextEvents
                                            text="*En caso contrario, marcar todos los procedimientos para Diciembre."
                                            color="gray"
                                            size='tiny'
                                            weight="light"
                                        />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Paper className={classes.rootPaper} style={{fontSize: '10px'}}>
                            <Grid container direction='row'>
                                    <Grid item xs={12}>
                                        <Divider orientation="left" style={styles.dividerDefault}>Firmantes (varios)</Divider>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextEvents
                                                text='Elaborado por: '
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                        />
                                        <ACCPSupervisorTableContainer>
                                            {(params)=> {
                                                return  <Select
                                                            showSearch
                                                            optionFilterProp="children"
                                                            mode='multiple'
                                                            style={styles.inputSelect}
                                                            placeholder='Selecciona una opción'
                                                            onChange={(v, i) => handleChange(v, i, 'employeeName')}
                                                        >
                                                            {SelectACCPItem(params.accpSupervisor, 'employeeName')}
                                                        </Select>
                                            }}
                                        </ACCPSupervisorTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <ACCPBossTableContainer>
                                            {(params)=> {
                                                return  <TextInput
                                                            text='Jefe de AC y CP'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                            placeholder='Selecciona jefe de ac y cp'
                                                            style={styles.inputSelect}
                                                            showSearch
                                                            onChange={(v) => {
                                                                findACCPBoss(params, v);
                                                            }}
                                                        >
                                                            {SelectItem(params.accpBoss, 'employeeName')}
                                                        </TextInput>
                                            }}
                                        </ACCPBossTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <ACCPSupervisorTableContainer>
                                            {(params)=> {
                                                return  <TextInput
                                                            text='Supervisor de AC y CP'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                            placeholder='Selecciona supervisor de ac y cp'
                                                            style={styles.inputSelect}
                                                            showSearch
                                                            onChange={(v) => {
                                                                findACCP(params, v);
                                                            }}
                                                        >
                                                            {SelectItem(params.accpSupervisor, 'employeeName')}
                                                        </TextInput>
                                            }}
                                        </ACCPSupervisorTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextEvents
                                            text='Representante de SSPA'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <SSPARepresentativeTableContainer>
                                                {(params)=> {
                                                    return (
                                                        <Select
                                                            showSearch
                                                            optionFilterProp="children"
                                                            mode='multiple'
                                                            style={styles.inputSelect}
                                                            placeholder='Selecciona representante de sspa'
                                                            onChange={(v, i) => handleChange(v, i, 'responsibleName')}
                                                        >
                                                            {SelectSSPAItem(params.sspaRepresentative, 'responsibleName')}
                                                        </Select>
                                                    )
                                                }}
                                            </SSPARepresentativeTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextEvents
                                                text='Representante Técnico'
                                                color='darker'
                                                size='label'
                                                weight='medium'
                                            />
                                            <TechnicalRepresentativeTableContainer>
                                                {(params)=> {
                                                    return  <Select
                                                                showSearch
                                                                optionFilterProp="children"
                                                                mode='multiple'
                                                                style={styles.inputSelect}
                                                                placeholder='Selecciona representante técnico'
                                                                onChange={(v, i) => handleChange(v, i, 'techResponsibleName')}
                                                            >
                                                                {SelectTechnicalRepItem(params.technicalRepresentative, 'responsibleName')}
                                                            </Select>
                                                }}
                                            </TechnicalRepresentativeTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <AdministrativeRepresentativeTableContainer>
                                            {(params)=> {
                                                return  <TextInput
                                                            text='Representante administrativo'
                                                            color='darker'
                                                            size='label'
                                                            weight='medium'
                                                            placeholder='Selecciona representante administrativo'
                                                            style={styles.inputSelect}
                                                            showSearch
                                                            onChange={(v) => {
                                                                findAdminRep(params, v);
                                                            }}
                                                        >
                                                            {SelectItem(params.administrativeRepresentative, 'responsibleName')}
                                                        </TextInput>
                                            }}
                                        </AdministrativeRepresentativeTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                    <TextEvents
                                            text='Representante PEP'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <PEPRepresentativeTableContainer>
                                                {(params)=> {
                                                    return (
                                                        <Select
                                                            showSearch
                                                            optionFilterProp="children"
                                                            mode='multiple'
                                                            style={styles.inputSelect}
                                                            placeholder='Selecciona representante pep'
                                                            onChange={(v, i) => handleChange(v, i, 'PEPresponsibleName')}
                                                        >
                                                            {SelectPEPItem(params.sspaRepresentative, 'responsibleName')}
                                                        </Select>
                                                    )
                                                }}
                                            </PEPRepresentativeTableContainer>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div className={classes.container} style={styles.baseVerticalMargin}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="primary"
                                                onClick={onSubmit}
                                                loading={isVisiblePDF}
                                                disabled={ front === '' || ACCP === '' || accpBoss === '' || adminRep === '' || pep === '' || tr === '' || sspa === '' || accp === ''}
                                                >
                                                Generar
                                            </Button>
                                        </div>
                                    </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                {isVisiblePDF ? <Drawer
                title={<div className={classes.headerDrawer}><Button onClick={()=> setVisiblePDF(false)} type='link' icon='left'>Regresar </Button><TextEvents
                            text={'Visualización de pdf'}
                            color='dark'
                            size='label'
                            weight='bold'
                        /></div>}
                placement="right"
				width={'100%'}
                bodyStyle={{height: '90%'}}
                closable={true}
                onClose={()=> setVisiblePDF(false)}
                visible={isVisiblePDF}
                >
                    <div style={{height: '100%', display: 'flex'}}>
                        <embed src={PDFData.UrlFile} width="100%" height="100%"  type="application/pdf"/>
                    </div>
            </Drawer> : ''}
            </div>
        </div>
    )
}